






























import { Component, Prop, Vue } from 'vue-property-decorator'
import { AccountPageRecord } from '@/api/model/account'
import { Form } from 'element-ui'
import $Api from '@api'
import { translate } from '@/utils/filters'
import FormValidator from '@/utils/form-validator'

interface DialogFormData extends AccountPageRecord {
    amount: number
}

@Component
export default class RechargeDialog extends Vue {
    @Prop({ default: false })
    private isShownRechargelDialog!: boolean

    @Prop()
    private dialogFormData!: DialogFormData

    formValidator = new FormValidator()

    rules = {
        amount: [
            { validator: this.formValidator.number(), trigger: 'blur' },
            { required: true, message: translate('nav.account.company.formData.recharge.amount.required'), trigger: 'blur' }
        ]
    }

    confirm(): void {
        ;(this.$refs['rechargeForm'] as Form).validate(valid => {
            if (valid) {
                this.rechargeSubmit()
            }
        })
    }

    rechargeSubmit(): void {
        const { amount, currency, id } = this.dialogFormData
        $Api.accountService.recharge({ amount, currency, id }).subscribe(
            res => {
                this.$message({
                    message: translate('common.success'),
                    type: 'success'
                })
                this.handleClose({ isRefresh: true })
            },
            error => {
                this.$notify.error(error.message)
            }
        )
    }

    handleClose({ isRefresh }): void {
        if (isRefresh) {
            this.$emit('refresh')
        }
        this.$emit('close')
        this.reset('rechargeForm')
    }

    reset(formName: string): void {
        ;(this.$refs[formName] as Form).resetFields()
    }
}
